import { render, staticRenderFns } from "./TheMenuContacts.vue?vue&type=template&id=d3686370&scoped=true&"
import script from "./TheMenuContacts.vue?vue&type=script&lang=js&"
export * from "./TheMenuContacts.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuContacts.vue?vue&type=style&index=0&id=d3686370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3686370",
  null
  
)

export default component.exports